import produce from 'immer';

import { FETCH_EVENT_LIST_FAILURE, FETCH_EVENT_LIST_SUCCESS } from '@actions/systemEvent';

const initialState: IEventStore = {
  events: null,
  error: null,
};

export default (state: IEventStore = initialState, action: any) =>
  produce(state, (draftState: IEventStore) => {
    switch (action.type) {
      case FETCH_EVENT_LIST_SUCCESS:
        draftState.events = action.response;
        draftState.error = null;

        return;

      case FETCH_EVENT_LIST_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
